import { ChangeDetectionStrategy, Component, computed, inject, input, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { PostItem } from '@app/core/models';
import { SHARED_MODULES } from '@app/shared';
import { Checker, notNull } from '@app/shared/utils';
import { AppSelectors } from '@app/store';
import { Store } from '@ngrx/store';
import { map, Observable } from 'rxjs';

@Component({
  imports: [SHARED_MODULES],
  templateUrl: './subtitle-daily.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubtitleDailyComponent {
  protected readonly isEmployee: Signal<boolean>;
  protected readonly item = input<PostItem>();
  protected readonly data: Signal<PostItem[]>;
  private readonly _store = inject(Store);

  constructor() {
    this.isEmployee = toSignal(this.selectEmployee(), { initialValue: false });
    this.data = computed(() => {
      const item = this.item();
      if (this.isEmployee()) {
        const metadata = [item.metadata.group, item.metadata.subject, item.metadata.author];
        return metadata.filter((data) => !!data);
      }
      return [item.metadata.subject, item.metadata.author].filter((data) => !!data);
    });
  }

  private selectEmployee(): Observable<boolean> {
    return this._store.select(AppSelectors.DefaultFunction).pipe(
      notNull(),
      map((functionId) => Checker.isEmployee(functionId)),
    );
  }
}
